import FilterBar from "../../../../components/topBarFilter";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  LinearProgress,
  linearProgressClasses,
  Modal,
  Paper,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import ButtonTime from "../../../../components/buttonTime";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import CircularProgressWithLabel from "../../../../components/circularProgressWithLabel";
import { Cached } from "@mui/icons-material";
import useStyles from "./styles";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import CardDataComponent from "../../../../components/overview/cardDataComponent";
import DatagridComponent from "../../../../components/datagridComponent";
import { useOutletContext } from "react-router-dom";
import DonutChartComponent from "./charts/donutChartComponent";
import GraficoAlternavel from "./charts/chartAlternable";
import TicketModalContent from "../../../../components/tickets/detailsTicketComponent";
import { alpha, bgcolor, minWidth } from "@mui/system";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { set } from "zod";
import HistogramAtendimentos from "./charts/histogramChartComponent";
import InternoModalConfirmacaoSaida from "../../../../components/modalSaindoDaPagina";
import TicketModalContentIxc from "../../../../components/tickets/detailsTicketIxcComponent";

export default function DashAtendimentos() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";
  const [openFilter, setOpenFilter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isValidRange, setIsValidRange] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [linearPercent, setLinearPercent] = useState(0);
  const clearFuncionariosRef = useRef(false);
  const clearRegionalRef = useRef(false);
  const clearPopRef = useRef(false);
  //states
  const [value, setValue] = useState(0);
  const [snackbar, setSnackbar] = useState(null);
  const [ticketDetails, setTicketDetails] = useState(null);
  const [totalAtendimentoForClient, setTotalAtendimentoForClient] = useState(
    [],
  );
  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });
  const [totalCards, setTotalCards] = useState([]);
  const [allAtendimentos, setAllAtendimentos] = useState([]);
  const [allOs, setAllOS] = useState([]);
  const [totalAtendimentosForTecnico, setTotalAtendimentosForTecnico] =
    useState([]);
  const [atendimentosForTempoEspera, setAtendimentosForTempoEspera] = useState(
    [],
  );
  const [OSForTecnico, setOSForTecnico] = useState([]);
  const [rowsAtendimentos, setRowsAtendimentos] = useState([]);
  const [chartTotalAtendimentos, setChartTotalAtendimentos] = useState([]);
  const [allPopRegional, setAllPopRegional] = useState([]);
  const [rowsPop, setRowsPop] = useState([]);
  const [filtroFuncionarios, setFiltroFuncionarios] = useState([]);
  const [filtroPop, setFiltroPop] = useState([]);
  const [filtroRegional, setFiltroRegional] = useState([]);
  const [histogramData, setHistogramData] = useState([]);

  const [isEditTicket, setIsEditTicket] = useState(false);
  const [isFinishTicket, setIsFinishTicket] = useState(false);
  const [isEditOs, setIsEditOs] = useState(false);
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [isNewOs, setIsNewOs] = useState(false);
  //CONTADOR DE CRONOMETRO E VERIFICADOR DE FILTRO
  // const [counter, setCounter] = useState(null);

  const [isConexoes, setIsConexoes] = useState(false);
  //LOADING
  const [loadingTicketDetails, setLoadingTicketDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingCronometro, setLoadingCronometro] = useState(false);
  const [loadingCards, setLoadingCards] = useState(false);
  const [loadingAtendimentoForClient, setLoadingAtendimentoForClient] =
    useState(false);
  const [loadingAtendimentoForTecnico, setLoadingAtendimentoForTecnico] =
    useState(false);
  const [loadingAtendimentos, setLoadingAtendimentos] = useState(false);
  const [loadingAtendimentoForTime, setLoadingAtendimentoForTime] =
    useState(false);
  const [loadingOSForTecnico, setLoadingOSForTecnico] = useState(false);
  const [loadingAtendimentosGeral, setLoadingAtendimentosGeral] =
    useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loadingOS, setLoadingOS] = useState(false);
  const [loadingPopRegional, setLoadingPopRegional] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [loadingHistogram, setLoadingHistogram] = useState(false);
  const prevRegionalRef = useRef([]);
  const prevPopRef = useRef([]);
  const prevFuncionariosRef = useRef([]);
  //FILTROS
  const [allFuncionarios, setAllFuncionarios] = useState([]);
  const [allPop, setAllPop] = useState([]);
  const [allRegional, setAllRegional] = useState([]);
  const [selectTime, setSelectTime] = useState(9);
  const [filterData, setFilterData] = useState({
    clienteId: "",
    serviceId: "",
    interfaceId: "",
    hostId: "",
    initialDate: dayjs()
      .subtract(6, "hour")
      .set("second", 0)
      .set("millisecond", 0)
      .toDate(),
    finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
  });
  const { controllerDashboard, setControllerDashboard, api } =
    useOutletContext();
  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const chipStatusAtendimento = (status) => {
    switch (status) {
      case "Pendente":
        return (
          <Tooltip title={"Pendente"}>
            <Chip size="small" sx={styles.chipPendente} label={"Pendente"} />
          </Tooltip>
        );
      case "Aguardando Análise":
        return (
          <Tooltip title={"Aguardando Análise"}>
            <Chip size="small" sx={styles.chipAndamento} label={"Aguardando"} />
          </Tooltip>
        );
      case "Resolvido":
        return (
          <Tooltip title={"Resolvido"}>
            <Chip size="small" sx={styles.chipResolvido} label={"Resolvido"} />
          </Tooltip>
        );
      case "Em progresso":
        return (
          <Tooltip title={"Em progresso"}>
            <Chip
              size="small"
              sx={styles.chipAndamento}
              label={"Em progresso"}
            />
          </Tooltip>
        );
      case "Solucionado":
        return (
          <Tooltip title={"Solucionado"}>
            <Chip
              size="small"
              sx={styles.chipResolvido}
              label={"Solucionado"}
            />
          </Tooltip>
        );
      case "Novo":
        return (
          <Tooltip title={"Novo"}>
            <Chip size="small" sx={styles.chipNovo} label={"Novo"} />
          </Tooltip>
        );
      default:
        return (
          <Tooltip title={"Cancelado"}>
            <Chip size="small" sx={styles.chipDefault} label="Cancelado" />
          </Tooltip>
        );
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const now = dayjs();
    setIsValidRange(
      dayjs.isDayjs(startDate) &&
        dayjs.isDayjs(endDate) &&
        startDate.isValid() &&
        endDate.isValid() &&
        !startDate.isAfter(endDate) &&
        !endDate.isBefore(startDate) &&
        !startDate.isAfter(now) &&
        !endDate.isAfter(now),
    );
  }, [endDate, startDate]);

  useEffect(() => {
    if (filterData?.initialDate && filterData?.finalDate) {
      fetchAllData();
    }
  }, [filterData]);

  //NÃO DA RELOAD NOS FILTROS
  useEffect(() => {
    if (clearFuncionariosRef.current && filtroFuncionarios?.length === 0) {
      fetchAllData();
      clearFuncionariosRef.current = false;
    }
  }, [filtroFuncionarios]);
  useEffect(() => {
    if (clearPopRef.current && filtroPop?.length === 0) {
      fetchAllData();
      clearPopRef.current = false;
    }
  }, [filtroPop]);
  useEffect(() => {
    if (clearRegionalRef.current && filtroRegional?.length === 0) {
      fetchAllData();
      clearRegionalRef.current = false;
    }
  }, [filtroRegional]);

  useEffect(() => {
    if (!allFuncionarios?.length) return;

    setFiltroFuncionarios((prevSelecionados) =>
      prevSelecionados
        ?.map((sel) => allFuncionarios?.find((f) => f?.id === sel?.id))
        ?.filter(Boolean),
    );
  }, [allFuncionarios]);

  useEffect(() => {
    if (!allPop?.length) return;

    setFiltroPop((prevSelecionados) =>
      prevSelecionados
        ?.map((sel) => allPop?.find((f) => f?.id === sel?.id))
        ?.filter(Boolean),
    );
  }, [allPop]);

  useEffect(() => {
    if (!allRegional?.length) return;

    setFiltroRegional((prevSelecionados) =>
      prevSelecionados
        ?.map((sel) => allRegional?.find((f) => f?.id === sel?.id))
        ?.filter(Boolean),
    );
  }, [allRegional]);
  ////////////////////////////////////////////////
  useEffect(() => {
    filterDashAtendimentos();
  }, []);
  //filtro de tempo opções
  const optionsTime = {
    0: {
      value: dayjs()
        .subtract(5, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 5 minutos",
    },
    1: {
      value: dayjs()
        .subtract(15, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 15 minutos",
    },
    2: {
      value: dayjs()
        .subtract(30, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 30 minutos",
    },
    3: {
      value: dayjs()
        .subtract(1, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Última hora",
    },
    4: {
      value: dayjs()
        .subtract(3, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 3 horas",
    },
    5: {
      value: dayjs()
        .subtract(6, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 6 horas",
    },
    6: {
      value: dayjs()
        .subtract(12, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 12 horas",
    },
    7: {
      value: dayjs()
        .subtract(24, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 24 horas",
    },
    8: {
      value: dayjs()
        .subtract(2, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 2 dias",
    },
    9: {
      value: dayjs()
        .subtract(7, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 7 dias",
    },
    10: {
      value: dayjs()
        .subtract(30, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 30 dias",
    },
    11: {
      value: dayjs()
        .subtract(90, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 90 dias",
    },
    12: {
      value: dayjs()
        .subtract(6, "month")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 6 meses",
    },
  };
  //promise all para buscar todos os dados
  const fetchAllData = async () => {
    setLoadingCronometro(true);
    let dateInitial = filterData?.initialDate;
    let finalDate = filterData?.finalDate;

    if (selectTime || selectTime === 0) {
      dateInitial = optionsTime[selectTime]?.value;
      finalDate = dayjs().set("second", 0).set("millisecond", 0).toDate();
    }
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    await Promise.all([
      getAtendimentosCliente(dateInitial, finalDate, signal),
      getCountAtendimentos(dateInitial, finalDate, signal),
      getAtendimentos(dateInitial, finalDate, signal),
      getAtendimentosTecnico(dateInitial, finalDate, signal),
      getAtendimentosForTime(dateInitial, finalDate, signal),
      getOSForTecnico(dateInitial, finalDate, signal),
      getAtendimentosTable(dateInitial, finalDate, signal),
      getOs(dateInitial, finalDate, signal),
      getPopRegional(dateInitial, finalDate, signal),
      getHistogram(dateInitial, finalDate, signal),
    ]);
    if (!signal.aborted) {
      setLoadingCronometro(false);
      // startCronometro();
    }
  };

  //functions
  const handleCloseSearch = () => {
    setConfirmacaoSaidaPagina(false);
    setIsEditTicket(false);
    setIsFinishTicket(false);
    setIsEditOs(false);
    setIsNewOs(false);
    setTicketDetails(null);
    setOpenModal(false);
    setValue(0);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStartChange = (newValue) => {
    setStartDate(newValue);
    if (newValue?.isAfter(endDate)) {
      setEndDate(newValue);
    }
  };
  const handleEndChange = (newValue) => {
    setEndDate(newValue);
  };
  const handleAplicar = () => {
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs(startDate).toDate(),
      finalDate: dayjs(endDate).toDate(),
    }));
    setSelectTime(null);
    handleClose();
  };

  const handleAplicarZoom = (startDate, endDate) => {
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs(startDate).toDate(),
      finalDate: dayjs(endDate).toDate(),
    }));
    setSelectTime(null);
    handleClose();
  };

  const handleSelectTime = (key) => {
    setSelectTime(key);
    setStartDate(null);
    setEndDate(null);
    handleClose();

    setFilterData((prev) => ({
      ...prev,
      initialDate: optionsTime[key]?.value,
      finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
    }));
  };
  const handleOnCloseFilter = (prevFilter, filtro) => {
    const prev = prevFilter.current;
    const curr = filtro;

    const prevIds = prev?.map((r) => r?.id)?.sort();
    const currIds = curr?.map((r) => r?.id)?.sort();

    const changed = JSON?.stringify(prevIds) !== JSON?.stringify(currIds);

    if (changed) {
      fetchAllData();
    }
  };
  //função que calcula a porcentagem com base no total de atendimentos por cliente
  const calcularPorcentagemAtendimentos = (data) => {
    if (!data || data?.length === 0) return [];

    const total = data?.reduce(
      (acc, item) => acc + Number(item?.totalAtendimentos || item?.totalOs),
      0,
    );

    return data?.map((item) => ({
      ...item,
      porcentagem:
        total > 0
          ? (Number(item?.totalAtendimentos || item?.totalOs) / total) * 100
          : 0,
    }));
  };
  //converte o objeto para array de objetos
  const convertRegionsToChartData = (regions) => {
    return Object?.entries(regions ?? {})?.map(([key, value]) => ({
      name: key,
      value,
    }));
  };
  const extractIds = (values) => {
    return values?.map((item) => item?.id) || [];
  };

  //collumns datagrid
  const columnsPop = [
    { field: "namePop", headerName: "POP", flex: 1, minWidth: 150 },
    {
      field: "value",
      headerName: "Quantidade de POP",
      flex: 1.5,
      minWidth: 100,
      renderCell: (params) => (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Tooltip
            title={
              params?.row?.namePop === "Não cadastrado" ? (
                <>
                  <strong>POPs não cadastrados:</strong>
                  <br />
                  Porcentagem: {params?.row?.porcentagem?.toFixed(2)}%
                </>
              ) : (
                <>
                  <strong>{params?.row?.namePop}:</strong>
                  <br />
                  Porcentagem: {params?.row?.porcentagem?.toFixed(2)}%
                </>
              )
            }
            slotProps={{
              tooltip: {
                sx: {
                  padding: 1,
                  backgroundColor: alpha(
                    theme.palette.paletteCharts.lineCharts,
                    0.9,
                  ),
                  borderRadius: 1,
                  color: theme.palette.text.main,
                },
              },
            }}
            placement="top"
          >
            <LinearProgress
              variant="determinate"
              value={params?.row?.porcentagem}
              sx={{
                ...styles.linearProgress,

                [`&.${linearProgressClasses.colorPrimary}`]: {
                  backgroundColor: `${theme.palette.colors.gray.dark}2c`,
                },
                [`& .${linearProgressClasses.bar}`]: {
                  borderRadius: 5,
                  backgroundColor:
                    params?.row?.namePop === "Não cadastrado"
                      ? `${theme.palette.colors.gray.medium}95`
                      : theme?.palette.colors.pink.medium,
                },
              }}
            />
          </Tooltip>
          <Typography variant="body2" sx={{ marginTop: "4px", fontSize: 12 }}>
            {`${params?.row?.value}`}
          </Typography>
        </Box>
      ),
    },
  ];
  const columnsAtendimentos = [
    {
      field: "serviceID",
      headerName: "Serviço ID",
      minWidth: 90,
      flex: 0.5,
    },
    {
      field: "protocolo",
      headerName: "Protocolo",
      minWidth: 170,
      flex: 0.5,
      renderCell: (params) => {
        return (
          <Typography
            sx={{
              fontSize: "0.85rem",
              cursor: "pointer",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
            onClick={() => {
              setOpenModal(true);
              getOsDetailsForProtocolo(params?.value);
            }}
          >
            {params?.value}
          </Typography>
        );
      },
    },

    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      flex: 0.5,
      renderCell: (params) => {
        return chipStatusAtendimento(params.value);
      },
    },
    {
      field: "dataAbertura",
      headerName: "Data de Abertura",
      minWidth: 130,
      flex: 0.7,
    },
    {
      field: "dataFechamento",
      headerName: "Data de Finalização",
      minWidth: 150,
      flex: 0.7,
    },
    {
      field: "cliente",
      headerName: "Cliente",
      minWidth: 250,
      flex: 1.5,
      renderCell: (params) => (
        <Tooltip title={params.value || ""} arrow placement="top-start">
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              display: "block",
            }}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "tecnico",
      headerName: "Tecnico",
      minWidth: 250,
      minWidth: 250,
      flex: 1,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      minWidth: 330,
      minWidth: 250,
      flex: 3,
    },
    {
      field: "quantidadeOS",
      headerName: "Total de OS",
      minWidth: 95,
      flex: 0.5,
      align: "center",
    },
  ];
  const getAtendimentoColumns = (
    field,
    displayName,
    percentField = "porcentagem",
    headerNamePercent = "Quantidade de Atendimentos",
    typeColor = 0,
  ) => [
    {
      field: field,
      headerName: displayName,
      flex: 1.5,
      minWidth: 250,
      renderCell: (params) => (
        <Tooltip title={params.value || ""} arrow placement="top-start">
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              display: "block",
            }}
          >
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: percentField,
      headerName: headerNamePercent,
      flex: 1,
      minWidth: 100,
      renderCell: (params) => (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Tooltip
            title={
              <>
                <strong>{params?.row?.tecnico || params?.row?.cliente}</strong>
                <br />
                {`Porcentagem: ${params.value.toFixed(2)}%`}
              </>
            }
            placement="top"
            slotProps={{
              tooltip: {
                sx: {
                  padding: 1,
                  backgroundColor: alpha(
                    theme.palette.paletteCharts.lineCharts,
                    0.9,
                  ),
                  borderRadius: 1,
                  color: theme.palette.text.main,
                },
              },
            }}
          >
            <LinearProgress
              variant="determinate"
              value={params.value}
              sx={{
                ...styles.linearProgress,
                [`&.${linearProgressClasses.colorPrimary}`]: {
                  backgroundColor: `${theme.palette.colors.gray.dark}2c`,
                },
                [`& .${linearProgressClasses.bar}`]: {
                  borderRadius: 5,
                  backgroundColor:
                    typeColor === 0
                      ? theme?.palette.colors.blue.medium
                      : typeColor === 1
                        ? theme?.palette.colors.purple.medium
                        : theme?.palette.colors.green.light,
                },
              }}
            />
          </Tooltip>
          <Typography variant="body2" sx={{ marginTop: "4px", fontSize: 12 }}>
            {`${params.row.totalAtendimentos || params.row.totalOs}`}
          </Typography>
        </Box>
      ),
    },
  ];

  //rotas
  const getAtendimentosCliente = async (dateInitial, dateFinal, signal) => {
    setLoadingAtendimentoForClient(true);
    try {
      const response = await api.post(
        "/find/getAtendimentosForClient",
        {
          initial_date: dateInitial,
          final_date: dateFinal,
          filterAtendente: extractIds(filtroFuncionarios),
          filterPop: extractIds(filtroPop),
          filterRegional: extractIds(filtroRegional),
        },
        { signal },
      );

      // pega o array dentro do objeto
      const data = response.data?.atendimentosPorCliente || [];

      // formata para o DataGrid
      const formatted = data?.map((item, index) => ({
        id: index + 1,
        cliente: item?.cliente,
        totalAtendimentos: Number(item?.totalAtendimentos),
      }));
      setLinearPercent(calcularPorcentagemAtendimentos(formatted));
      setTotalAtendimentoForClient(formatted);
    } catch (error) {
      console.error("Erro ao buscar atendimentos:", error);
      setTotalAtendimentoForClient([]);
    } finally {
      if (!signal.aborted) {
        setLoadingAtendimentoForClient(false);
      }
    }
  };
  const getAtendimentosTecnico = async (dateInitial, dateFinal, signal) => {
    setLoadingAtendimentoForTecnico(true);
    try {
      const response = await api.post(
        "/find/atendimentosForTecnico",
        {
          initial_date: dateInitial,
          final_date: dateFinal,
          filterAtendente: extractIds(filtroFuncionarios),
          filterPop: extractIds(filtroPop),
          filterRegional: extractIds(filtroRegional),
        },
        { signal },
      );

      const data = response?.data?.atendimentosPorTecnico || [];

      const formatted = data?.map((item, index) => ({
        id: item?.idTecnico,
        tecnico: item?.tecnico,
        totalAtendimentos: Number(item?.totalAtendimentos),
      }));

      setTotalAtendimentosForTecnico(
        calcularPorcentagemAtendimentos(formatted),
      );
    } catch (error) {
      console.error("Erro ao buscar atendimentos:", error);
    } finally {
      if (!signal?.aborted) {
        setLoadingAtendimentoForTecnico(false);
      }
    }
  };
  //rota dos cards
  const getCountAtendimentos = async (dateInitial, dateFinal, signal) => {
    setLoadingCards(true);
    try {
      const response = await api.post(
        "/find/getCountAtendimentos",
        {
          initial_date: dateInitial,
          final_date: dateFinal,
          filterAtendente: extractIds(filtroFuncionarios),
          filterPop: extractIds(filtroPop),
          filterRegional: extractIds(filtroRegional),
        },
        { signal },
      );
      const data = response?.data || [];

      setTotalCards(data);
      const formatted = [
        {
          abertos: Number(data?.totalNovosAtendimentos),
          fechados: Number(data?.totalAtendimentosResolvidos),
          total:
            Number(data?.totalNovosAtendimentos) +
            Number(data?.totalAtendimentosResolvidos),
        },
      ];

      setChartTotalAtendimentos(formatted);
    } catch (error) {
      console.error("Erro ao buscar contagem de atendimentos:", error);
    } finally {
      if (!signal.aborted) {
        setLoadingCards(false);
      }
    }
  };
  //rota  da serie temporal
  const getAtendimentos = async (dateInitial, dateFinal, signal) => {
    setLoadingAtendimentos(true);
    try {
      const response = await api.post(
        "/find/serieTemporal/atendimentos",
        {
          initial_date: dateInitial,
          final_date: dateFinal,
          filterAtendente: extractIds(filtroFuncionarios),
          filterPop: extractIds(filtroPop),
          filterRegional: extractIds(filtroRegional),
        },
        { signal },
      );

      setAllAtendimentos(response?.data?.serieAtendimentos || []);
    } catch (error) {
      console.error("Erro ao buscar atendimentos:", error);
    } finally {
      if (!signal.aborted) {
        setLoadingAtendimentos(false);
      }
    }
  };
  const getOs = async (dateInitial, dateFinal, signal) => {
    setLoadingOS(true);
    try {
      const response = await api.post(
        "/find/serieTemporal/os",
        {
          initial_date: dateInitial,
          final_date: dateFinal,
          filterAtendente: extractIds(filtroFuncionarios),
          filterPop: extractIds(filtroPop),
          filterRegional: extractIds(filtroRegional),
        },
        { signal },
      );

      setAllOS(response?.data?.serieOs || []);
    } catch (error) {
      console.error("Erro ao buscar atendimentos:", error);
    } finally {
      if (!signal.aborted) {
        setLoadingOS(false);
      }
    }
  };
  const getAtendimentosForTime = async (dateInitial, dateFinal, signal) => {
    setLoadingAtendimentoForTime(true);
    try {
      const response = await api.post(
        "/find/getAtendimentosForTempoEspera",
        {
          initial_date: dateInitial,
          final_date: dateFinal,
          filterAtendente: extractIds(filtroFuncionarios),
          filterPop: extractIds(filtroPop),
          filterRegional: extractIds(filtroRegional),
        },
        { signal },
      );
      setAtendimentosForTempoEspera(
        response?.data?.atendimentoPorTempoEspera || [],
      );
    } catch (error) {
      console.error("Erro ao buscar atendimentos:", error);
    } finally {
      if (!signal.aborted) {
        setLoadingAtendimentoForTime(false);
      }
    }
  };
  const getOSForTecnico = async (dateInitial, dateFinal, signal) => {
    setLoadingOSForTecnico(true);
    try {
      const response = await api.post(
        "/find/osForTecnico",
        {
          initial_date: dateInitial,
          final_date: dateFinal,
          filterAtendente: extractIds(filtroFuncionarios),
          filterPop: extractIds(filtroPop),
          filterRegional: extractIds(filtroRegional),
        },
        { signal },
      );
      const data = response?.data?.osPorTecnico || [];

      const formatted = data?.map((item, index) => ({
        id: item?.idTecnico,
        tecnico: item?.tecnico,
        totalOs: Number(item?.totalOs),
      }));
      setOSForTecnico(calcularPorcentagemAtendimentos(formatted));
    } catch (error) {
      console.error("Erro ao buscar OS por técnico:", error);
    } finally {
      if (!signal.aborted) {
        setLoadingOSForTecnico(false);
      }
    }
  };
  const getAtendimentosTable = async (dateInitial, dateFinal, signal) => {
    setLoadingAtendimentosGeral(true);
    try {
      const response = await api.post(
        "/find/getAtendimentosDash",
        {
          initial_date: dateInitial,
          final_date: dateFinal,
          filterAtendente: extractIds(filtroFuncionarios),
          filterPop: extractIds(filtroPop),
          filterRegional: extractIds(filtroRegional),
        },
        { signal },
      );

      const data = response.data.atendimentos || [];
      const formatted = data?.map((item, index) => ({
        id: item?.id_atendimento,
        protocolo: item?.protocolo,
        serviceID: item?.servico?.id_cliente_servico,
        status: item?.status,
        dataAbertura: dayjs(item?.data_cadastro)?.format("DD/MM/YYYY HH:mm"),
        dataFechamento:
          item?.data_fechamento &&
          dayjs(item?.data_fechamento)?.format("DD/MM/YYYY HH:mm"),
        cliente: item?.cliente?.nome || "",
        tecnico: item?.usuario_fechamento,
        descricao: item?.descricao_abertura,
        quantidadeOS: item?.os,
      }));

      setRowsAtendimentos(formatted);
    } catch (error) {
      console.error("Erro ao buscar atendimentos:", error);
    } finally {
      if (!signal.aborted) {
        setLoadingAtendimentosGeral(false);
      }
    }
  };
  const getPopRegional = async (dateInitial, dateFinal, signal) => {
    setLoadingPopRegional(true);
    try {
      const response = await api.post(
        "/find/getCountAtendimentosForPopReginal",
        {
          initial_date: dateInitial,
          final_date: dateFinal,
          filterAtendente: extractIds(filtroFuncionarios),
          filterPop: extractIds(filtroPop),
          filterRegional: extractIds(filtroRegional),
        },
        { signal },
      );
      const dataPop = response?.data?.popReginal?.pop || [];
      const totalPop = Object?.values(dataPop)?.reduce((acc, v) => acc + v, 0);

      const rowsPopFormatted = Object?.entries(dataPop)?.map(
        ([key, value], index) => ({
          id: index + 1,
          namePop: key,
          value: value,
          total: totalPop,
          porcentagem: (value / totalPop) * 100,
        }),
      );

      setRowsPop(rowsPopFormatted);
      setAllPopRegional(response?.data?.popReginal);
    } catch (error) {
    } finally {
      if (!signal.aborted) {
        setLoadingPopRegional(false);
      }
    }
  };
  const getHistogram = async (dateInitial, dateFinal, signal) => {
    setLoadingHistogram(true);
    try {
      const response = await api.post(
        "/find/histograma/atendimentos",
        {
          initial_date: dateInitial,
          final_date: dateFinal,
          filterAtendente: extractIds(filtroFuncionarios),
          filterPop: extractIds(filtroPop),
          filterRegional: extractIds(filtroRegional),
        },
        { signal },
      );

      setHistogramData(response?.data?.serieAtendimentos || []);
    } catch (error) {
      console.error("Erro ao buscar atendimentos:", error);
    } finally {
      if (!signal.aborted) {
        setLoadingHistogram(false);
      }
    }
  };
  const getOsDetailsForProtocolo = async (protocolo) => {
    setLoadingTicketDetails(true);
    try {
      const response = await api.post(`/interno/ticketDetails/protocolo`, {
        protocolo: protocolo?.trim(),
      });

      setTicketDetails(response?.data);
      setItensPublic((prev) => {
        const mensagens = [];
        const anexos = [];
        const anexosCliente = [];
        const rfo = [];
        for (const item of response?.data?.itensTicketPublic || []) {
          if (item?.itemType === "mensagem") {
            mensagens.push(item?.itemId);
          } else if (item?.itemType === "anexo") {
            anexos?.push(item?.itemId);
          } else if (item?.itemType === "anexoCliente") {
            anexosCliente?.push(item?.itemId);
          } else if (item?.itemType === "rfo") {
            rfo?.push(item?.itemId);
          }
        }

        return {
          ...prev,
          mensagens,
          anexos,
          anexosCliente,
          rfo,
        };
      });
    } catch (error) {
      setTicketDetails(null);
      console.log(error);
      setSnackbar({
        children: "Protocolo não encontrado",
        severity: "warning",
      });
    } finally {
      setLoadingTicketDetails(false);
    }
  };
  //ROTAS DE FILTROS
  const filterDashAtendimentos = async () => {
    setLoadingFilter(true);
    try {
      const response = await api.get("/find/filterDashAtendimentos");

      setAllFuncionarios(response.data.atendentes);
      setAllPop(response.data.pop);
      setAllRegional(response.data.regional);
    } catch (error) {
    } finally {
      setLoadingFilter(false);
    }
  };

  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };
  //mobile filter
  const actions = [
    {
      icon: <FilterAltOutlinedIcon />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
    ...(selectTime || selectTime === 0
      ? [
          {
            icon: <Cached />,
            name: "Atualizar",
            onClick: () => handleSelectTime(selectTime),
          },
        ]
      : []),
  ];

  const cardProps =
    erp === "HUBSOFT"
      ? { xs: 12, sm: 6, md: 4, lg: 4, xl: 2, xxl: 2 }
      : { xs: 12, sm: 6, md: 6, lg: 3 };

  return (
    <Box>
      <FilterBar
        actions={actions}
        selectorComponentLeft={
          <Box
            sx={{
              display: "flex",
              gap: 1,
              "@media (max-width:1349px)": {
                flexDirection: "column",
              },
              width: "100%",
            }}
          >
            <Box sx={styles.autocompleteFilter}>
              <Autocomplete
                disableCloseOnSelect
                multiple
                options={allFuncionarios || []}
                size="small"
                getOptionLabel={(option) => option?.name}
                disabled={loadingFilter}
                value={filtroFuncionarios}
                onChange={(e, newValue, reason) => {
                  if (reason === "clear") {
                    clearFuncionariosRef.current = true;

                    setFiltroFuncionarios([]);
                    return;
                  }
                  setFiltroFuncionarios(newValue);
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={selected}
                      style={{ marginRight: 8 }}
                    />
                    {option?.name}
                  </li>
                )}
                onOpen={() => {
                  prevFuncionariosRef.current = [...filtroFuncionarios];
                }}
                onClose={() => {
                  handleOnCloseFilter(prevFuncionariosRef, filtroFuncionarios);
                }}
                sx={styles.autocomplete}
                renderTags={(selected, getTagProps) => (
                  <Tooltip
                    title={
                      selected.length ? (
                        <Box>
                          {selected.map((func) => (
                            <Typography key={func.id} sx={{ fontSize: 10 }}>
                              {func?.name}
                            </Typography>
                          ))}
                        </Box>
                      ) : (
                        "Nenhum atendente selecionado"
                      )
                    }
                  >
                    <Box
                      sx={{
                        maxWidth: "100%",
                      }}
                    >
                      {selected.length === 1 ? (
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{
                            maxWidth: "100%",
                          }}
                        >
                          {selected[0]?.name}
                        </Typography>
                      ) : (
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{
                            overflow: "hidden",
                            maxWidth: "100%",
                          }}
                        >
                          {selected?.length} Atendentes
                        </Typography>
                      )}
                    </Box>
                  </Tooltip>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Atendentes"
                    sx={styles.autocompleteText}
                  />
                )}
              />
              {loadingFilter && <LinearProgress />}
            </Box>
            <Box sx={styles.autocompleteFilter}>
              <Autocomplete
                disableCloseOnSelect
                multiple
                options={allRegional || []}
                onOpen={() => {
                  prevRegionalRef.current = [...filtroRegional];
                }}
                onClose={() => {
                  handleOnCloseFilter(prevRegionalRef, filtroRegional);
                }}
                getOptionLabel={(option) => option?.tagName}
                size="small"
                disabled={loadingFilter}
                value={filtroRegional}
                onChange={(e, newValue, reason) => {
                  if (reason === "clear") {
                    clearRegionalRef.current = true;

                    setFiltroRegional([]);
                    return;
                  }
                  setFiltroRegional(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Regional"
                    sx={styles.autocompleteText}
                  />
                )}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={selected}
                      style={{ marginRight: 8 }}
                    />
                    {option?.tagName}
                  </li>
                )}
                renderTags={(selected, getTagProps) => (
                  <Tooltip
                    title={
                      selected.length ? (
                        <Box>
                          {selected.map((regional) => (
                            <Typography key={regional.id} sx={{ fontSize: 10 }}>
                              {regional?.tagName}
                            </Typography>
                          ))}
                        </Box>
                      ) : (
                        "Nenhum regional selecionado"
                      )
                    }
                  >
                    <Box sx={{}}>
                      {selected.length === 1 ? (
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{
                            maxWidth: "100%",
                          }}
                        >
                          {selected[0]?.tagName}
                        </Typography>
                      ) : (
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{
                            overflow: "hidden",
                            maxWidth: "100%",
                          }}
                        >
                          {selected?.length} regionais selecionados
                        </Typography>
                      )}
                    </Box>
                  </Tooltip>
                )}
              />
              {loadingFilter && <LinearProgress />}
            </Box>
            <Box sx={styles.autocompleteFilter}>
              <Autocomplete
                disableCloseOnSelect
                multiple
                options={allPop || []}
                size="small"
                getOptionLabel={(option) => option?.tagName}
                disabled={loadingFilter}
                onOpen={() => {
                  prevPopRef.current = [...filtroPop];
                }}
                onClose={() => {
                  handleOnCloseFilter(prevPopRef, filtroPop);
                }}
                value={filtroPop}
                onChange={(e, newValue, reason) => {
                  if (reason === "clear") {
                    clearPopRef.current = true;

                    setFiltroPop([]);
                    return;
                  }
                  setFiltroPop(newValue);
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={selected}
                      style={{ marginRight: 8 }}
                    />
                    {option?.tagName}
                  </li>
                )}
                sx={styles.autocomplete}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="POP"
                    sx={styles.autocompleteText}
                  />
                )}
                renderTags={(selected, getTagProps) => (
                  <Tooltip
                    title={
                      selected.length ? (
                        <Box>
                          {selected.map((pop) => (
                            <Typography key={pop.id} sx={{ fontSize: 10 }}>
                              {pop?.tagName}
                            </Typography>
                          ))}
                        </Box>
                      ) : (
                        "Nenhum POP selecionado"
                      )
                    }
                  >
                    <Box sx={{}}>
                      {selected.length === 1 ? (
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{
                            maxWidth: "100%",
                          }}
                        >
                          {selected[0]?.tagName}
                        </Typography>
                      ) : (
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{
                            overflow: "hidden",
                            maxWidth: "100%",
                          }}
                        >
                          {selected?.length} POPs selecionados
                        </Typography>
                      )}
                    </Box>
                  </Tooltip>
                )}
              />
              {loadingFilter && <LinearProgress />}
            </Box>
          </Box>
        }
        type={1}
        selectorComponentRight={
          <Box sx={{ display: "flex", gap: 1 }}>
            {!isConexoes && (
              <ButtonTime
                open={open}
                optionsTime={optionsTime}
                selectTime={selectTime}
                handleClick={handleClick}
                anchorEl={anchorEl}
                handleClose={handleClose}
                loading={loading}
                handleStartChange={handleStartChange}
                handleEndChange={handleEndChange}
                handleAplicar={handleAplicar}
                isValidRange={isValidRange}
                endDate={endDate}
                startDate={startDate}
                setEndDate={setEndDate}
                setStartDate={setStartDate}
                setSelectTime={setSelectTime}
                handleSelectTime={handleSelectTime}
                filterData={filterData}
                DateTime={DateTimePicker}
              />
            )}

            {(selectTime || selectTime === 0 || loadingCronometro) &&
            windowWidth >= 1350 ? (
              <Button
                size="small"
                variant="outlined"
                disabled={loadingCronometro}
                onClick={() => handleSelectTime(selectTime)}
                sx={{
                  ...styles.buttonRefresh,
                  "& .rotating": {
                    animation: "spin 1s linear infinite",
                  },
                  "@keyframes spin": {
                    "0%": {
                      transform: "rotate(0deg)",
                    },
                    "100%": {
                      transform: "rotate(-360deg)",
                    },
                  },
                }}
              >
                <Cached
                  fontSize="small"
                  sx={{ color: theme.palette.text.main }}
                  className={loadingCronometro ? "rotating" : ""}
                />
              </Button>
            ) : null}
          </Box>
        }
        setOpenFilter={setOpenFilter}
        openFilter={openFilter}
        windowWidth={30000}
      />
      <Grid item xs={2} sm={4} md={6} lg={6}>
        <Grid
          container
          columns={{ xs: 2, sm: 4, md: 12, lg: 3, xl: 6, xxl: 6 }}
          spacing={1}
        >
          <Grid item xs={2} sm={4} md={12} lg={3} xl={6} xxl={6}>
            <Grid container spacing={1} columns={12}>
              <Grid item {...cardProps}>
                <CardDataComponent
                  cardTile={"Total de novos atendimentos"}
                  cardValue={totalCards?.totalNovosAtendimentos || 0}
                  cardTextColor={"chip.main.waitingReview"}
                  typeIcon={17}
                  colorCard="pendente"
                  loading={loadingCards}
                  paramsColor={{
                    card: theme.palette.colors.pink.dark,
                    icon: theme.palette.colors.pink.light,
                    container: theme.palette.colors.pink.darker,
                  }}
                />
              </Grid>
              <Grid item {...cardProps}>
                <CardDataComponent
                  cardTile={"Total de atendimentos resolvidos"}
                  cardValue={totalCards?.totalAtendimentosResolvidos || 0}
                  cardTextColor={"chip.main.waitingReview"}
                  typeIcon={14}
                  colorCard="statusUp"
                  loading={loadingCards}
                />
              </Grid>
              {erp === "HUBSOFT" && (
                <>
                  <Grid item {...cardProps}>
                    <CardDataComponent
                      cardTile={"Aguardando Análise"}
                      cardValue={totalCards?.totalAtendimentosAgAnalise || 0}
                      cardTextColor={"chip.main.waitingReview"}
                      typeIcon={15}
                      colorCard="inputData"
                      loading={loadingCards}
                    />
                  </Grid>
                  <Grid item {...cardProps}>
                    <CardDataComponent
                      cardTile={"Pendentes"}
                      cardValue={totalCards?.totalAtendimentosPendente || 0}
                      cardTextColor={"chip.main.waitingReview"}
                      typeIcon={16}
                      colorCard="outputData"
                      loading={loadingCards}
                    />
                  </Grid>
                </>
              )}

              <Grid item {...cardProps}>
                <CardDataComponent
                  cardTile={"Total de novos OS"}
                  cardValue={totalCards?.totalOs || 0}
                  cardTextColor={"chip.main.waitingReview"}
                  typeIcon={17}
                  colorCard="speeData"
                  loading={loadingCards}
                />
              </Grid>
              <Grid item {...cardProps}>
                <CardDataComponent
                  cardTile={"Total de OS resolvidos"}
                  cardValue={totalCards?.totalOsResolvidos || 0}
                  cardTextColor={"chip.main.waitingReview"}
                  typeIcon={14}
                  colorCard="statusUp"
                  loading={loadingCards}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2} sm={4} md={6} lg={6} xl={3} display="flex">
            <GraficoAlternavel
              data={allAtendimentos}
              loading={loadingAtendimentos}
              titleGraph="Atendimentos por dia"
              handleAplicarZoom={handleAplicarZoom}
              isZoomEnabled={true}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={6} lg={6} xl={3} display="flex">
            <GraficoAlternavel
              data={allOs}
              loading={loadingOS}
              titleGraph="OS por dia"
              handleAplicarZoom={handleAplicarZoom}
              isZoomEnabled={true}
            />
          </Grid>

          <Grid item xs={2} sm={4} md={12} lg={6} xl={3} display="flex">
            <Box sx={styles.boxCards}>
              <Paper
                sx={styles.paperDatagrid}
                elevation={theme.palette.mode == "dark" ? 0 : 3}
              >
                <DonutChartComponent
                  data={atendimentosForTempoEspera}
                  title="Atendimentos finalizados"
                  loading={loadingAtendimentoForTime}
                  type={0}
                />
              </Paper>
              <Paper
                sx={styles.paperDatagrid}
                elevation={theme.palette.mode == "dark" ? 0 : 3}
              >
                <DonutChartComponent
                  data={chartTotalAtendimentos}
                  title="Total de Atendimentos"
                  loading={loadingCards}
                  type={1}
                />
              </Paper>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={3} display="flex">
            <Box sx={styles.boxCards}>
              <Paper
                sx={styles.paperDatagrid}
                elevation={theme.palette.mode == "dark" ? 0 : 3}
              >
                <DonutChartComponent
                  data={convertRegionsToChartData(allPopRegional?.regional)}
                  title="Atendimentos por regional"
                  loading={loadingPopRegional}
                  type={0}
                />
              </Paper>
              <Paper
                sx={styles.paperDatagrid}
                elevation={theme.palette.mode == "dark" ? 0 : 3}
              >
                {loadingPopRegional && (
                  <LinearProgress sx={styles.loadingLinearProgress} />
                )}

                <Typography sx={styles.titleCardMenor}>
                  Atendimentos por POP
                </Typography>
                <Divider />

                <Box sx={styles.boxDatagridMenor}>
                  <DatagridComponent
                    rows={rowsPop}
                    columns={columnsPop}
                    sxDatagrid={{
                      maxHeight: 150,
                      overflowY: "auto",
                      "& .MuiDataGrid-virtualScroller": {
                        overflowY: "auto !important",
                      },
                    }}
                  />
                </Box>
              </Paper>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={3} display="flex">
            <Box sx={styles.boxCards}>
              <Paper
                sx={{ ...styles.paperDatagrid, pt: 2 }}
                elevation={theme.palette.mode == "dark" ? 0 : 3}
              >
                {loadingAtendimentoForClient && (
                  <LinearProgress sx={styles.loadingLinearProgress} />
                )}
                <Typography variant="h8" sx={styles.boxTitleDatagrid}>
                  Atendimentos abertos por cliente
                </Typography>
                <Divider sx={{ pt: 1 }} />
                <Box sx={styles.boxDatagrid}>
                  <DatagridComponent
                    title={"Atendimentos por cliente"}
                    rows={linearPercent}
                    columns={getAtendimentoColumns(
                      "cliente",
                      "Nome do Cliente",
                    )}
                    sxDatagrid={{
                      maxHeight: 150,
                      overflowY: "auto",
                      "& .MuiDataGrid-virtualScroller": {
                        overflowY: "auto !important",
                      },
                    }}
                  />
                </Box>
              </Paper>
              <Paper
                sx={{ ...styles.paperDatagrid, pt: 2 }}
                elevation={theme.palette.mode == "dark" ? 0 : 3}
              >
                {loadingAtendimentoForTecnico && (
                  <LinearProgress sx={styles.loadingLinearProgress} />
                )}
                <Typography variant="h8" sx={styles.boxTitleDatagrid}>
                  Atendimentos resolvidos por atendente
                </Typography>
                <Divider sx={{ pt: 1 }} />
                <Box sx={styles.boxDatagrid}>
                  <DatagridComponent
                    title={"Atendimentos por técnico"}
                    rows={totalAtendimentosForTecnico}
                    columns={getAtendimentoColumns(
                      "tecnico",
                      "Nome do Atendente",
                      "porcentagem",
                      "Quantidade de Atendimentos",
                      2,
                    )}
                    sxDatagrid={{
                      maxHeight: 150,
                      overflowY: "auto",
                      "& .MuiDataGrid-virtualScroller": {
                        overflowY: "auto !important",
                      },
                    }}
                  />
                </Box>
              </Paper>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={3} display="flex">
            <Box sx={styles.boxCards}>
              <Paper
                sx={{ ...styles.paperDatagrid, pt: 2 }}
                elevation={theme.palette.mode == "dark" ? 0 : 3}
              >
                {loadingOSForTecnico && (
                  <LinearProgress sx={styles.loadingLinearProgress} />
                )}
                <Typography variant="h8" sx={styles.boxTitleDatagrid}>
                  Técnicos por OS
                </Typography>
                <Divider sx={{ pt: 1 }} />
                <Box sx={styles.boxDatagrid}>
                  <DatagridComponent
                    title={"Atendimentos por cliente"}
                    rows={OSForTecnico}
                    columns={getAtendimentoColumns(
                      "tecnico",
                      "Nome do Técnico",
                      "porcentagem",
                      "Quantidade de OS",
                      1,
                    )}
                    sxDatagrid={{
                      maxHeight: 150,
                      overflowY: "auto",
                      "& .MuiDataGrid-virtualScroller": {
                        overflowY: "auto !important",
                      },
                    }}
                  />
                </Box>
              </Paper>

              <Paper
                sx={styles.paperDatagrid}
                elevation={theme.palette.mode == "dark" ? 0 : 3}
              >
                {loadingHistogram && (
                  <LinearProgress sx={styles.loadingLinearProgress} />
                )}
                <HistogramAtendimentos
                  title="Atendimentos abertos por hora"
                  data={histogramData}
                />
              </Paper>
            </Box>
          </Grid>
          <Grid item xs={2} sm={4} md={12} lg={6} xl={6} display="flex">
            <Paper
              sx={{
                ...styles.paperDatagrid,
                maxHeight: "500px",
                pt: 2,
              }}
              elevation={theme.palette.mode == "dark" ? 0 : 3}
            >
              {loadingAtendimentosGeral && (
                <LinearProgress sx={styles.loadingLinearProgress} />
              )}
              <Typography variant="h8" sx={styles.boxTitleDatagrid}>
                Atendimentos
              </Typography>
              <Divider sx={{ pt: 1 }} />
              <Box
                sx={{
                  display: "flex",
                  height: "350px",
                }}
              >
                <DatagridComponent
                  title={"Atendimentos por cliente"}
                  rows={rowsAtendimentos}
                  columns={columnsAtendimentos}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>

        <>
          {erp === "IXC" ? (
            <TicketModalContentIxc
              open={openModal}
              loading={loadingTicketDetails}
              handleClose={handleCloseSearch}
              erp={erp}
              ticketDetails={ticketDetails}
              status={ticketDetails?.status}
              labelTabsErp={labelTabsErp}
              value={value}
              handleChange={handleChange}
              isEdit={true}
              setTicketDetails={setTicketDetails}
              itensPublic={itensPublic}
              setItensPublic={setItensPublic}
              setSnackbar={setSnackbar}
              setIsEditTicket={setIsEditTicket}
              isEditTicket={isEditTicket}
              setIsFinishTicket={setIsFinishTicket}
              isFinishTicket={isFinishTicket}
              isEditOs={isEditOs}
              setIsEditOs={setIsEditOs}
              setIsNewOs={setIsNewOs}
              isNewOs={isNewOs}
            />
          ) : (
            <TicketModalContent
              open={openModal}
              handleClose={handleCloseSearch}
              loading={loadingTicketDetails}
              erp={erp}
              ticketDetails={ticketDetails}
              status={ticketDetails?.status}
              labelTabsErp={labelTabsErp}
              value={value}
              handleChange={handleChange}
              isEdit={true}
              setTicketDetails={setTicketDetails}
              itensPublic={itensPublic}
              setItensPublic={setItensPublic}
              setSnackbar={setSnackbar}
              setIsEditTicket={setIsEditTicket}
              isEditTicket={isEditTicket}
              setIsFinishTicket={setIsFinishTicket}
              isFinishTicket={isFinishTicket}
              isEditOs={isEditOs}
              setIsEditOs={setIsEditOs}
              setIsNewOs={setIsNewOs}
              isNewOs={isNewOs}
            />
          )}
        </>

        <InternoModalConfirmacaoSaida
          openConfirmacao={confirmacaoSaidaPagina}
          confirmLoad={false}
          setOpenConfirmacao={setConfirmacaoSaidaPagina}
          execute={handleCloseSearch}
          cancel={handleCancelNavigation}
          severity={"warning"}
          title={"Atenção"}
          contentText={
            "As alterações não salvas serão perdidas, deseja continuar?"
          }
          headerText={"Você está prestes a sair do modo de edição."}
          confirmText={"Continuar"}
        />
      </Grid>
    </Box>
  );
}
